import { AppServices } from '@singularsystems/neo-core';

import { IAuthorisationApiClient } from './Services/ApiClients/AuthorisationApiClient';
import { IAuthorisationManagementService } from './Services/AuthorisationManagementService';

// Symbols to expose outside of this module
export const AuthorisationSharedTypes = {
    ApiClients: {
        AuthorisationApiClient: new AppServices.ServiceIdentifier<IAuthorisationApiClient>("Authorisation.ApiClients.AuthorisationApiClient"),
    },
    Services: {
        AuthorisationManagementService: new AppServices.ServiceIdentifier<IAuthorisationManagementService>("Authorisation.Services.AuthorisationManagementService"),
    }
}